var map = {
	"./40_coin.png": "21f6",
	"./50_coin.png": "b74e",
	"./attend-img.png": "ec53",
	"./auto-lotto-icon.png": "f14c",
	"./default_thum.png": "355d",
	"./event-bg.png": "bbd6",
	"./event-img.png": "46e5",
	"./kan.png": "462b",
	"./logo-web3pays.svg": "9fb4",
	"./logo.png": "4ffd",
	"./logo.svg": "1ae4",
	"./logo_black.svg": "69fa",
	"./logo_image.svg": "1f1d",
	"./logo_p.png": "eb25",
	"./logo_p.svg": "c488",
	"./lotto_banner_img.png": "3787",
	"./manual-lotto-icon.png": "f653",
	"./nft-placeholder.svg": "eea7",
	"./pay_img.png": "a3fa",
	"./picaso-logo.png": "5964"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";